import styled from 'styled-components';
import { tablet768, desktop1024 } from '@nubank/nuds-web/styles/breakpoints';

export const Section = styled.div`
  padding: 3rem 1.5rem;
  text-align: center;

  ${tablet768`
    padding: 5rem 2.5rem;
  `}

  ${desktop1024`
    padding: 8rem 10.625rem;
    display: flex;
    flex-direction: column;
    align-items: center;
  `}
`;

Section.displayName = 'Section';

export const ImageContainer = styled.div`
  padding: 2rem  0;

  ${tablet768`
    padding: 3rem 0;
  `}
`;

ImageContainer.displayName = 'ImageContainer';
